import PropTypes from 'prop-types';
import Col from 'react-bootstrap//Col';
import Pay360Session from './Pay360Session';
import PaymentProcessing from './PaymentProcessing';

function PaymentCardHosted({
  paymentProcessing,
  paymentProcessingFailed,
  redirectUrl,
  sessionState,
  transactionState,
  basketAmount,
}) {
  return (
    <div className="layout-scrollable--payment-with-terms payment-wrapper" id="otrl-payment">
      <div className="payment-container">
        <div>
          <section>
            <Col xs={12} className="payment__content full-height">
              <div className="payment__header-container">
                <h3 className="payment__header sr-only">Pay by card</h3>
              </div>

              {paymentProcessing ? (
                <PaymentProcessing />
              ) : (
                <Pay360Session
                  paymentProcessing={paymentProcessing}
                  paymentProcessingFailed={paymentProcessingFailed}
                  src={redirectUrl}
                  sessionState={sessionState}
                  transactionState={transactionState}
                  amount={basketAmount}
                />
              )}
            </Col>
          </section>
        </div>
      </div>
    </div>
  );
}

PaymentCardHosted.propTypes = {
  paymentProcessing: PropTypes.bool,
  paymentProcessingFailed: PropTypes.bool,
  redirectUrl: PropTypes.string,
  sessionState: PropTypes.string,
  transactionState: PropTypes.string,
  basketAmount: PropTypes.number,
};

export default PaymentCardHosted;
